import { render, staticRenderFns } from "./EducationalJoiningApplicationCards.vue?vue&type=template&id=61194040&"
import script from "./EducationalJoiningApplicationCards.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports